// import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";
import "./Home.css";
import React, { useState, useEffect } from "react";
import axios from "axios";

// const taskStatusData = [
//   { name: "Completed", value: 220 },
//   { name: "In Progress", value: 80 },
//   { name: "Pending", value: 40 },
// ];

// const leaveData = [
//   { name: "Granted", value: 18 },
//   { name: "Pending", value: 6 },
// ];

// const attendanceData = [
//   { name: "Present", value: 120 },
//   { name: "Absent", value: 10 },
//   { name: "On Leave", value: 5 },
// ];

const COLORS_TASK = ["#28a745", "#17a2b8", "#ffc107"]; // green, cyan, yellow
const COLORS_LEAVE = ["#28a745", "#ffc107"];
const COLORS_ATT = ["#007bff", "#dc3545", "#6f42c1"]; // blue, red, purple

const SummaryCard = ({ title, value, hint }) => (
  <div className="dcard summary-dcard">
    <div className="card-body">
      <h5 className="card-title">{title}</h5>
      <div className="card-value">{value}</div>
      {hint && <div className="card-hint">{hint}</div>}
    </div>
  </div>
);

const Home = () => {
  // const totalTasks = taskStatusData.reduce((s, d) => s + d.value, 0);
  // const totalLeaves = leaveData.reduce((s, d) => s + d.value, 0);
  // const totalAttendance = attendanceData.reduce((s, d) => s + d.value, 0);
  const [dashboard, setDashboard] = useState({});
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    // setLoading(true);
    axios.post(`${API_BASE_URL}dashboard.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setDashboard(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDashboard([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDashboard([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  // Task Status
  const totalTasksApi = Number(dashboard.total_task);
  const completedTasks = Number(dashboard.total_complete_task);
  const inProgressTasks = Number(dashboard.total_progress_task);
  const pendingTasks = Number(dashboard.total_assigned_task); // No value in API—set manually or adjust if you have field

  const taskStatusData = [
    { name: "Completed", value: completedTasks },
    { name: "In Progress", value: inProgressTasks },
    { name: "Pending", value: pendingTasks }
  ];

  const totalTasks = taskStatusData.reduce((s, d) => s + d.value, 0);

  // Leave Status
  const totalLeavesApi = Number(dashboard.total_leave);
  const grantedLeaves = Number(dashboard.total_approved_leave);
  const pendingLeaves = Number(dashboard.total_approved_leave);

  const leaveData = [
    { name: "Granted", value: grantedLeaves },
    { name: "Pending", value: pendingLeaves }
  ];

  const totalLeaves = leaveData.reduce((s, d) => s + d.value, 0);

  // Attendance (No API fields → Keeping static unless provided)
  // Leave Status
  const totalLeaveList = Number(dashboard.total_leave_list);
  const totalPresentList = Number(dashboard.total_present_list);
  const totalAbsentList = Number(dashboard.total_absent_list);

  const attendanceData = [
    { name: "Present", value: totalPresentList },
    { name: "Absent", value: totalAbsentList },
    { name: "On Leave", value: totalLeaveList }
  ];

  const totalAttendance = attendanceData.reduce((s, d) => s + d.value, 0);

  return (
    <div className="dashboard">
      <h2 className="dashboard-title">Dashboard Overview</h2>

      <div className="card-container">
        <SummaryCard title="Total Users" value={dashboard.total_user} />
        <SummaryCard title="OD Requests" value={dashboard.total_od} />
        <SummaryCard title="Total Tasks" value={dashboard.total_task} hint={`${dashboard.total_complete_task} completed`} />
        <SummaryCard title="Leave Requests" value={dashboard.total_leave} hint={`${dashboard.total_approved_leave} granted`} />
      </div>

      <div className="charts-row">
        <div className="chart-card">
          <h4 className="chart-title">Task Status</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={taskStatusData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={38}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalTasks) * 100)}%`}
                labelLine={false}
              >
                {taskStatusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS_TASK[index % COLORS_TASK.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card">
          <h4 className="chart-title">Leave Status</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={leaveData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={40}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalLeaves) * 100)}%`}
                labelLine={false}
              >
                {leaveData.map((entry, index) => (
                  <Cell key={`cell-leave-${index}`} fill={COLORS_LEAVE[index % COLORS_LEAVE.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card">
          <h4 className="chart-title">Attendance</h4>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={attendanceData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={36}
                paddingAngle={4}
                label={(entry) => `${Math.round((entry.value / totalAttendance) * 100)}%`}
                labelLine={false}
              >
                {attendanceData.map((entry, index) => (
                  <Cell key={`cell-att-${index}`} fill={COLORS_ATT[index % COLORS_ATT.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Home;
